export default "__VITE_ASSET__vlxlv$BQ__"